import axios from 'axios';

export const CompletedRequestsApi = {
  getRequests: filter => axios.get(
    `/api/self/paging/request_form?filter=${JSON.stringify(filter)}`
  )
};